__turbopack_context__.v({
  "headerText": "styles-module-scss-module__tXRq9G__headerText",
  "modalDescription": "styles-module-scss-module__tXRq9G__modalDescription",
  "submitButton": "styles-module-scss-module__tXRq9G__submitButton",
  "textarea": "styles-module-scss-module__tXRq9G__textarea",
});
